import snsAxiosClient from '../common/http/http-sns';

function reactivateSubscription(environmentVariables, user, subscriptionInfo) {
  const payload = { ...subscriptionInfo };
  const options = {
    headers: {
      ...environmentVariables.API_HEADERS_PATCH_V1,
      Authorization: `Bearer ${user.authToken}`,
    },
  };
  return snsAxiosClient(options).patch(
    `${environmentVariables.SNS_REACTIVATE_SUBSCRIPTION}${user.UUID}/reactivateSubscription`,
    payload,
  );
}

export default reactivateSubscription;
